import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <footer class="an-footer">
      <p>COPYRIGHT 2021 ©. ALL RIGHTS RESERVED</p>
    </footer> <!-- end an-footer -->
  `
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// G:/UTL/Student/Student-ANG/src/app/shared/footer/footer.component.ts